import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
import { withStyles } from '@material-ui/core/styles';
import { Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import ExpandableCell from 'components/SimpleTable/ExpandableCell';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
		margin: 16,
	},
	searchButton: {
		marginRight: 16,
	},
	searchTable: {
		minHeight: 600,
		marginTop: 30,
		marginRight: 32,
	},
	formField: {
		width: '100%',
	},
});

const searchCols = [
	{ name: 'CardCode', title: 'BP Code' },
	{ name: 'CardName', title: 'BP Name' },
	{ name: 'ContactName', title: 'Contact Name' },
	{ name: 'ContactPhone', title: 'Contact Phone' },
	{ name: 'ContactEmail', title: 'Contact Email' },
	{ name: 'Phone', title: 'BP Phone' },
	{ name: 'SalesEmployee', title: 'BP Sales Employee' },
	{ name: 'ContactPerson', title: 'BP Default Contact' },
	{ name: 'DealerGroup', title: 'BP Dealer Group' },
	{ name: 'Remarks', title: 'BP Remarks' },
	{ name: 'BPPriority', title: 'BP Priority' },
];



class ContactSearch extends React.PureComponent {
	state = {
		values: {
			CardCode: '',
			CardName: '',
			ContactName: '',
			ContactPhone: '',
			ContactEmail: '',
			Phone: '',
			DefaultContact: '',
		},
		searching: false,
		rows: [],
		redirect: '',
	};


	updateSearchVal = memoize(key => event => {
		this.setState({
			values: {
				...this.state.values,
				[ key ]: event.target.value,
			},
		});
	});


	handleSearch = ( e ) => {
		e.preventDefault();
		this.setState({ searching: true, rows: [] });

		svc.send('bp', { method: 'searchContacts', ...this.state.values }).then(res => {
			this.setState({
				searching: false,
				rows: res.payload.data,
			});
		});
	};


	onRowSelect = ( sel ) => {
		if ( !sel.length ) {
			return false;
		}

		let row = this.state.rows[ sel[ 0 ] ];
		this.setState({ redirect: `/businesspartners/view/${row.CardCode}` });
	};


	newBP = () => {
		this.setState({ redirect: '/businesspartners/new' });
	};




	render() {
		const classes = this.props.classes;
		const tableClass = classnames(classes.searchTable, this.state.searching && 'automat-loading');
		let values = this.state.values;

		return (
			<div>
				<form onSubmit={this.handleSearch} className={classes.formField}>
					<Grid container className={classes.gridRoot} spacing={16}>


						<Grid item xs={12}>
							<Typography variant="h6">Contact Search</Typography>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardCode}
								label="BP Code"
								onChange={this.updateSearchVal('CardCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardName}
								label="BP Name"
								onChange={this.updateSearchVal('CardName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.ContactName}
								label="Contact Name"
								onChange={this.updateSearchVal('ContactName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.ContactPhone}
								label="Contact Phone"
								onChange={this.updateSearchVal('ContactPhone')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.ContactEmail}
								label="Contact Email"
								onChange={this.updateSearchVal('ContactEmail')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.Phone}
								label="BP Phone"
								onChange={this.updateSearchVal('Phone')}
								className={classes.formField}
							/>
						</Grid>


						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.DefaultContact}
								label="BP Default Contact"
								onChange={this.updateSearchVal('DefaultContact')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={2}>
							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.handleSearch}
								disabled={this.state.searching}
								type={'submit'}
							>
								Search
							</Button>

							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.newBP}
							>
								Create New BP
							</Button>
						</Grid>

						<Grid item xs={12}>
							<Paper className={tableClass}>
								<SimpleTable
									columns={searchCols}
									rows={this.state.rows}
									onRowSelect={this.onRowSelect}
									defaultPageSize={15}
									cellComponent={ExpandableCell}
								/>
							</Paper>
						</Grid>

					</Grid>

					{
						this.state.redirect
						&& window.location.pathname !== this.state.redirect
						&& <Redirect to={this.state.redirect} push />
					}

				</form>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		appData: state.appData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch(actions.layout.setTitle(title));
		},
	}
};

ContactSearch = withStyles(styles)(ContactSearch);
export default connect(mapStateToProps, mapDispatchToProps)(ContactSearch);